import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { MsalService } from "@azure/msal-angular";
import { Store } from "@ngxs/store";
import { Users } from "county-api";
import { NotificationsService } from "src/app/universal/notifications/notifications.service";
import { UserState } from "src/app/users/store/user.state";
import { environment } from "src/environments/environment";
import { BranchSchedule } from "../branch-day-fleet-site-check";

@Component({
    selector: 'schedule',
    templateUrl: './schedule.component.html',
    styleUrls: ['./schedule.component.scss']
})
export class ScheduleComponent implements OnInit {

    /**
     *
     */
    constructor(private authService: MsalService,
                private httpservice: HttpClient,
                private store: Store,
                private route: ActivatedRoute,
                private router: Router,
                private notification: NotificationsService,) {
    }

    readonly locations: string[] = [
        "Stockport",
        "Oldham",
        "Preston",
        "Chester"
    ];

    retrievedId = "";

    locationSelected = "";

    selectedExceptionDate = "";

    isNewSchedule = true;

    exceptionDates = [];

    days = [
        { name: 'Monday', checked: false },
        { name: 'Tuesday', checked: false },
        { name: 'Wednesday', checked: false },
        { name: 'Thursday', checked: false },
        { name: 'Friday', checked: false },
        { name: 'Saturday', checked: false },
        { name: 'Sunday', checked: false }
    ];

    currentUser: Users.IUser;

    ngOnInit(): void {
        this.route.data.subscribe((data: { user: Users.IUser }) => {
                    this.currentUser = this.store.selectSnapshot(UserState.user);                
                });
        const params = this.route.snapshot.queryParams;
        
        if (params.id){
            this.retrievedId = params.id;
            this.isNewSchedule = false;
            this.loadData();
        }
    }

    addExceptionDate(){
        if (this.selectedExceptionDate.length > 0 && this.exceptionDates.map(x => x.value).indexOf(this.selectedExceptionDate) == -1){
            this.exceptionDates.push(this.mapDateString(this.selectedExceptionDate));
        }
        
        this.selectedExceptionDate = "";
    }

    mapDateString(dateString: string){
        return {
                value: dateString,
                displayedValue: this.formatDateTime(dateString),
                dateObject: new Date(dateString)
            };
    }

    deleteDateByIndex(index: number){
        this.exceptionDates.splice(index, 1);
    }

    formatDateTime(date: string){
        const fmt = new Intl.DateTimeFormat("en-GB", { 
            year: "numeric", 
            month: "2-digit", 
            day: "2-digit" 
        }
        );

        return fmt.format(new Date(date)).replace(",", "");
    }

    loadData(){
       const account = this.authService.instance.getAllAccounts()[0];
        const accessTokenRequest = {
            scopes: ["user.read"],
            account: account,
        };
         this.authService.acquireTokenSilent(accessTokenRequest).subscribe(x => {
                const accessToken = x.accessToken;

                if(this.retrievedId){
                    this.getSchedule(accessToken, this.retrievedId).subscribe(
                        x => {
                            this.onScheduleRetrieved(x.result);
                        }
                    );
                }
         })
    }

    onScheduleRetrieved(schedule: BranchSchedule){
        this.locationSelected = schedule.location;

        for(let day of this.days){
            day.checked = schedule.scheduled_week_days.indexOf(day.name) > -1;
        }

        const exceptions = schedule.exception_year_dates.split(",");
        for(let exception of exceptions){
            this.exceptionDates.push(this.mapDateString(exception));
        }
    }

    submitSchedule() {
            const account = this.authService.instance.getAllAccounts()[0];
            const accessTokenRequest = {
                scopes: ["user.read"],
                account: account,
               };
    
            this.authService.acquireTokenSilent(accessTokenRequest).subscribe(x => {
                const accessToken = x.accessToken;

                let schedule = {
                    location: this.locationSelected,
                    updated_by: this.currentUser.username,
                    scheduled_week_days: this.days.filter(x => x.checked).map(x => x.name).join(","),
                    exception_year_dates: this.exceptionDates.map(x => x.value).join(",")
                } as any;

                if(this.retrievedId){
                    schedule.id = this.retrievedId
                }
                
                this.postSchedule(accessToken, schedule).subscribe(
                    x => {
                        
                        this.notification.success("Schedule submitted");

                        this.isNewSchedule = false;

                        if(this.retrievedId.length == 0){
                            this.redirectToSchedules();
                        }
                    },
                errorResponse => {
                    if (errorResponse?.error?.result){
                            this.notification.error(errorResponse?.error?.result);
                            return;
                        }
                });
            });  
        };

    postSchedule(accessToken: string, schedule: any){
    
            const url = environment.apiUrl + `api/v2/branchschedules/Save`;
            const postObservable = this.httpservice.post<any>(
                url,
                schedule,
                {
                    headers: { 
                        "Authorization": accessToken,
                        'Accept': 'application/json', 
                    },
                    'responseType': 'json'
                },
            );
            return postObservable;
    }

    getSchedule(accessToken: string, id: any){
    
            const url = environment.apiUrl + `api/v2/branchschedules/Single?id=${id}`;
            const getObservable = this.httpservice.get<any>(
                url,
                {
                    headers: { 
                        "Authorization": accessToken,
                        'Accept': 'application/json', 
                    },
                    'responseType': 'json'
                },
            );
            return getObservable;
    }

    redirectToSchedules(){
        const url = '/site-checks/schedules';

        this.router.navigateByUrl(url);
    }

    get sortedExceptionDates(){
        return this.exceptionDates.sort((a, b) => b.dateObject.getTime() - a.dateObject.getTime());
    }

    get canSubmit(){
        return this.locationSelected.length > 0 && this.days.find(x => x.checked) != undefined
    }

    get title(){
        return this.isNewSchedule ? "Create Schedule" : "Save Schedule";
    }

}